import { Link } from "react-router-dom";
import type { NewsItem } from "@/utils/content";
import { formatDate } from "@/utils/content";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row"
    >
      <div className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-auto sm:w-56">
        <img
          src={item.cover}
          alt={`${item.title} 资讯配图`}
          title={`火影忍者资讯 ${item.title}`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col py-1">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-700">
            {item.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {formatDate(item.date)}
          </span>
        </div>
        <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-auto pt-3 text-sm font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line ml-1" />
        </span>
      </div>
    </Link>
  );
}